import React, { useState, useEffect } from 'react';
import { View, ScrollView } from 'react-native';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import TabItem from './TabItem';
import { Typography } from '@hmsexp/component-library';
import styles from './style';

const TabbedHighchartsContainer = ({
    tabs = [],
    mode = 'single',
    disableTabClick = false,
    mainChartConfig = {},
    sparklineConfig = {},
    onTabClick,
    containerStyle
}) => {
    const [activeTabId, setActiveTabId] = useState(tabs[0]?.id);
    const [hoveredTabId, setHoveredTabId] = useState(null);

    useEffect(() => {
        if (tabs.length > 0 && !activeTabId) {
            setActiveTabId(tabs[0].id);
        }
    }, [tabs]);

    const handleTabClick = (tab) => {
        if (disableTabClick) return;
        setActiveTabId(tab.id);
        if (onTabClick) {
            onTabClick(tab);
        }
    };

    const activeTab = tabs.find(t => t.id === activeTabId) || tabs[0];

    const symbols = ['circle', 'square', 'diamond', 'triangle', 'triangle-down'];

    const getMainChartOptions = () => {
        let series = [];
        let titleText = '';
        let categories = []

        if (mode === 'single') {
            if (activeTab) {
                const symbol = symbols[tabs.findIndex(t => t.id === activeTab.id) % symbols.length];
                series = [{
                    name: activeTab.label,
                    data: activeTab.mainChartData || activeTab.sparklineData,
                    color: activeTab.color || '#7cb5ec',
                    marker: { symbol }
                }];
                categories = activeTab.categories;
                titleText = `${activeTab.label} Trend`;
            }
        } else {
            categories = tabs[0].categories;
            series = tabs.map((tab, index) => {
                const isHovered = hoveredTabId === tab.id;
                const isDimmed = hoveredTabId && !isHovered;
                const symbol = symbols[index % symbols.length];

                return {
                    name: tab.label,
                    data: tab.mainChartData || tab.sparklineData,
                    color: tab.color,
                    opacity: isDimmed ? 0.2 : 1,
                    lineWidth: isHovered ? 3 : 2,
                    zIndex: isHovered ? 2 : 1,
                    marker: {
                        enabled: true,
                        radius: isHovered ? 6 : 4,
                        symbol
                    }
                };
            });
            titleText = 'Combined Trend';
        }

        return {
            ...mainChartConfig,
            series: series,
            xAxis: { categories },
            title: { ...(mainChartConfig.title || {}) }
        };
    };

    return (
        <View style={[styles.container, containerStyle]}>
            <ScrollView horizontal showsHorizontalScrollIndicator={false} style={styles.tabsContainer}>
                {tabs.map((tab, index) => (
                    <TabItem
                        key={tab.id}
                        label={tab.label}
                        value={tab.value}
                        subValue={tab.subValue}
                        subLabel={tab.subLabel}
                        sparklineData={tab.sparklineData}
                        color={tab.color}
                        subValueColor={tab.subValueColor}
                        isActive={!disableTabClick && activeTabId === tab.id}
                        onPress={() => handleTabClick(tab)}
                        onHover={(isHovering) => setHoveredTabId(isHovering ? tab.id : null)}
                        sparklineConfig={sparklineConfig}
                        symbol={symbols[index % symbols.length]}
                    />
                ))}
            </ScrollView>

            <View style={styles.mainChartContainer}>
                <Typography variant='h6' fontWeightType='bold'
                    textProps={{ style: { marginBottom: 30 } }}
                >{activeTab?.label} </Typography>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={getMainChartOptions()}
                />
            </View>
        </View>
    );
};



export default TabbedHighchartsContainer;
